import type { OpsDashboardAlertsResponse } from '@nadoutong/contracts';
import { useQuery } from '@tanstack/react-query';
import type { UseQueryResult } from '@tanstack/react-query';
import { useSession } from '../hooks/useSession.tsx';
import { getDashboardAlerts } from './dashboardAlerts.ts';

/**
 * React Query wrapper for the Dashboard proactive-alert fan-out.
 *
 * Query key is flat because the endpoint takes no parameters — thresholds
 * are baked into the server-side handlers (Epic #109 / P0.3). If those
 * thresholds ever promote to per-operator preferences we'll widen the
 * key to include them alongside the `days` parameter that `useRouterStats`
 * carries.
 */

export const DASHBOARD_ALERTS_KEY = ['dashboard-alerts'] as const;

export function useDashboardAlerts(): UseQueryResult<OpsDashboardAlertsResponse> {
  const { fetchImpl } = useSession();
  return useQuery({
    queryKey: DASHBOARD_ALERTS_KEY,
    queryFn: ({ signal }) => getDashboardAlerts(fetchImpl, signal),
  });
}
